import { BaseApi } from './base.api.js';

export class BigdesCompensatoryControlApi extends BaseApi {
    constructor(client) {
        super(client, '/bigdes-compensatory-controls');
    }
}
